import { render, staticRenderFns } from "./UploadYMLPage.vue?vue&type=template&id=f97ecd58&scoped=true"
import script from "./UploadYMLPage.vue?vue&type=script&lang=js"
export * from "./UploadYMLPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ecd58",
  null
  
)

export default component.exports